import React from "react";
import { connect } from "react-redux";
import language from "../../language/index.js";
import { Table } from "../Table/index.js";
import {
  fetchReturnRequest,
  deleteReturnRequest,
} from "../../utils/queries/return-request";
import { getStorage } from "../../utils/storage.js";
import icons from "../../constants/icons.js";
import { DeleteModal, Modal } from "../Modal/index.js";
import ShippingQueue from "../Requests/shipping/ShippingQueue.js";
import ReturnRequest from "./Return.js";

// eslint-disable-next-line no-unused-vars
let copyData = [];

class HistoricalData extends React.Component {
  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
// eslint-disable-next-line no-dupe-keys
  };

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    await this.getData(true);
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({
      [field]: e?.target?.value,
      error,
    });
  }

  returnFilters = async (search) => {
    const { page, limit } = this.state;
    const { status } = this.props;
    return {
      page,
      limit,
      status,
      ...search,
    };
  };

  getData = async (isLoading, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoading });

      const { data, count, totalRecords } = await fetchReturnRequest(
        defaultLanguage,
        await this.returnFilters(search)
      );

      this.setState({
        data: data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      }
    );
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].return_number,
        key: "returnNumber",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", item.returnNumber, item),
      },
      {
        title: language[this.props.defaultLanguage].source,
        key: "from.name",
      },
      {
        title: language[this.props.defaultLanguage].destination,
        key: "to.name",
      },
      {
        title: language[this.props.defaultLanguage].status,
        key: "status",
        type: "status",
      },
      {
        title: language[this.props.defaultLanguage].account,
        key: "account.pin",
        style: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].date,
        key: "createdAt",
        isMoment: true,
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].action,
        key: "action",
      },
    ];

    return headers;
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({ [modal]: false }, () => {
      if (modal === "showModal") {
        this.getData(true);
      }
    });
  }

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.getData(true, {
      returnNumber: search || search !== "" ? search : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteReturnRequest(
        this.props.defaultLanguage,
        this.state.selectedData._id
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      this.setState({
        isDeleting: false,
      });
    }
  };

  // eslint-disable-next-line no-dupe-class-members
  onChangeText(field, e) {
  // eslint-disable-next-line no-dupe-class-members
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }
  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
          filters={[
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: () => this.getData(true, this.state.filters),
            },
          ]}
          actions={[
            {
              canAccess: true,
              name: language[this.props.defaultLanguage].view,
              icon: icons.eye_on,
              onPress: (item) =>
                this.handleShowModal("showModal", item.returnNumber, item),
            },
            {
              canAccess: true,
              name: language[this.props.defaultLanguage].edit,
              icon: icons.edit,
              isHidden: (item) => item.status?.toUpperCase() === "TRANSFERRED",
              onPress: (item) =>
                this.handleShowModal("showEditModal", language[this.props.defaultLanguage].edit, item),
            },
            {
              canAccess: true,
              icon: icons.delete,
              name: language[this.props.defaultLanguage].delete_,
              onPress: this.handleShowModal.bind(
                this,
                "showDeleteModal",
                language[this.props.defaultLanguage].delete_
              ),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          size="lg"
        >
          <div className="card-body">
            <ShippingQueue
              shipmentNumber={this.state.selectedData.returnNumber}
              isRefreshing={this.state.isRefreshing}
              addedBy={this.state?.user?._id}
              status={this.state.selectedData.status}
              isReturn
              handleCloseModal={this.handleCloseModal.bind(this, "showModal")}
            />
          </div>
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showEditModal")}
          show={this.state.showEditModal}
          title={this.state.modalTitle}
          size="lg"
        >
          {this.state.selectedData?._id && (
            <div style={{ padding: "1rem 1.5rem 1.5rem" }}>
              <ReturnRequest
                selectedData={this.state.selectedData}
                getData={this.getData.bind(this)}
                handleCloseModal={this.handleCloseModal.bind(this, "showEditModal")}
              />
            </div>
          )}
        </Modal>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal"
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(HistoricalData);
